'use strict';

module.exports = require('./lib/ReactDOMServer');



//////////////////
// WEBPACK FOOTER
// ../~/react-dom/server.js
// module id = 2799
// module chunks = 1